import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Card, CardContent, Container } from '@material-ui/core'
import Slider from 'react-slick'

import Avatar2 from '~/images/avatar1.jpg'
import Avatar3 from '~/images/avatar3.jpg'
import Avatar from '~/images/avatar4.jpg'
import translate from '~/locale'

import SectionSubtitle from '../SectionSubtitle'
import SectionTitle from '../SectionTitle'
import Quote from './Quote.svg'
import Star from './Star.svg'

function SliderArrowNext(props) {
  const { className, onClick } = props

  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-right']} />
    </div>
  )
}

function SliderArrowPrev(props) {
  const { className, onClick } = props

  return (
    <div className={className} onClick={onClick}>
      <FontAwesomeIcon icon={['fas', 'chevron-left']} />
    </div>
  )
}

const ResidentTestimonials: React.FC = () => {
  const sliderConfig = {
    dots: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SliderArrowNext />,
    prevArrow: <SliderArrowPrev />,
    responsive: [
      {
        breakpoint: 1100,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  }

  const testimonials = [
    {
      rating: 5,
      comment: 'referaltext1',
      title: 'referal_name',
      subtitle: 'referalroll',
      image: Avatar,
    },
    {
      rating: 5,
      comment: 'referaltext2',
      title: 'referal_name2',
      subtitle: 'referalroll',
      image: Avatar2,
    },
    {
      rating: 5,
      comment: 'referaltext3',
      title: 'referal_name3',
      subtitle: 'referalroll',
      image: Avatar3,
    },
  ]

  return (
    <div className="bg-blue-lighter">
      <Container className="py-6">
        <SectionTitle>{translate('whatresidentsaresaying')}</SectionTitle>
        <SectionSubtitle>
          {translate('consumers_expect_everything')}
        </SectionSubtitle>

        <Slider
          {...sliderConfig}
          className="slider-arrows-outside slider-arrows-dark slider-dots-outside mb-4"
        >
          {testimonials.map((testimonial, key) => (
            <div key={key}>
              <Card className="m-4">
                <CardContent>
                  <div className="align-box-row align-items-start">
                    <div>
                      <Card className="card-transparent">
                        <a
                          href="#/"
                          onClick={(e) => e.preventDefault()}
                          className="card-img-wrapper rounded"
                        >
                          <img
                            src={testimonial.image}
                            className="card-img-top rounded-circle"
                            style={{ width: 80 }}
                            alt={translate(testimonial.title)}
                          />
                        </a>
                      </Card>
                    </div>
                    <div className="pl-4">
                      <Quote />
                      <div className="my-3 text-warning font-size-lg">
                        <Star />
                        <Star />
                        <Star />
                        <Star />
                        <Star />
                      </div>
                      <blockquote className="my-3 text-black">
                        {translate(testimonial.comment)}
                      </blockquote>
                      <div className="font-size-lg text-black">
                        {translate(testimonial.title)}
                        <small className="text-black-50 pl-2">
                          {translate(testimonial.subtitle)}
                        </small>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </Slider>
      </Container>
    </div>
  )
}

export default ResidentTestimonials
